/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SILENT_LOGIN,
  UPDATE_PROFILE,
} from 'src/actions/accountActions';

const initialState = {
  user: null,
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST: {
      return produce(state, draft => {
        // Ensure we clear current session
        draft.user = null;
      });
    }

    case LOGIN_SUCCESS: {
      const { user, type } = action.payload;
      const objectUser = user[0];

      return produce(state, draft => {
        draft.user = { ...objectUser, type };
      });
    }

    case LOGIN_FAILURE: {
      return produce(state, () => {
        // Maybe store error
      });
    }

    case LOGOUT: {
      return produce(state, draft => {
        draft.user = null;
      });
    }

    case SILENT_LOGIN: {
      const { user, type } = action.payload;

      return produce(state, draft => {
        draft.user = { ...user, type };
      });
    }

    case UPDATE_PROFILE: {
      const { user } = action.payload;
      const objectUser = user[0];

      return produce(state, draft => {
        draft.user = objectUser;
      });
    }

    default: {
      return state;
    }
  }
};

export default accountReducer;
